import React, { useContext } from "react";

import {
    Switch,
    Route
} from "react-router-dom";
import AuthContext from "../Context/AuthContext";


import Login from "../components/pages/Login"
import Home from "../components/pages/Home"
import NewPlanPageLCW from "../components/pages/NewPlanPageLCWData"
import NewPlanPageBellona from "../components/pages/NewPlanPageBellona"
import NewPlanPageDominos from "../components/pages/NewPlanPageDominos"
import NewPlanPageDyson from "../components/pages/NewPlanPageDyson"
import NewPlanPageSS from "../components/pages/NewPlanPageSS"
import NewPlanPageToyota from "../components/pages/NewPlanPageToyota"
import NewPlanPageSahibinden from "../components/pages/NewPlanPageSahibinden"
import CampaignDetail from "../components/pages/CampaignDetail"

export default function Router() {
    const { userData } = useContext(AuthContext);
    const isViewer = userData?.user?.user?.role === "viewer";

    return (
        <div>
            <Switch>
                <Route path="/" exact component={Login} />
                <Route path="/login" component={Login} />
                <Route path="/homepage" component={Home} />
                <Route path="/CampaignDetail/:id" component={CampaignDetail} />
                {!isViewer && (
                    <Route path="/EditPlan/:id" component={NewPlanPageLCW} />
                )}
                {!isViewer && userData?.user?.user?.username === "LC Waikiki" ? (
                    <Route path="/NewPlan" component={NewPlanPageLCW} />

                ) : null}
                {!isViewer && userData?.user?.user?.username === "Bellona" ? (
                    <Route path="/NewPlan" component={NewPlanPageBellona} />

                ) : null}
                {!isViewer && userData?.user?.user?.username === "Domino's" ? (
                    <Route path="/NewPlan" component={NewPlanPageDominos} />

                ) : null}
                 {!isViewer && userData?.user?.user?.username === "saat&saat" ? (
                    <Route path="/NewPlan" component={NewPlanPageSS} />

                ) : null}
                 {!isViewer && userData?.user?.user?.username === "Toyota" ? (
                    <Route path="/NewPlan" component={NewPlanPageToyota} />

                ) : null}
                {!isViewer && userData?.user?.user?.username === "Dyson" ? (
                    <Route path="/NewPlan" component={NewPlanPageDyson} />

                ) : null}
                {!isViewer && userData?.user?.user?.username === "Sahibinden" ? (
                    <Route path="/NewPlan" component={NewPlanPageSahibinden} />

                ) : null}

            </Switch>


        </div>
    )
}
